export const INC_STEP = 'zola/onboard/INC_STEP';
export const DEC_STEP = 'zola/onboard/DEC_STEP';
export const RESET_STEP = 'zola/onboard/RESET_STEP';
export const CHECK_SLUG_AVAILABLE = 'zola/onboard/CHECK_SLUG_AVAILABLE';
export const SLUG_AVAILABILITY_RECEIVED = 'zola/onboard/SLUG_AVAILABILITY_RECEIVED';
export const PRIMARY_PRODUCT_SELECTED = 'zola/onboard/PRIMARY_PRODUCT_SELECTED';
export const SLUG_SUGGESTIONS_RECEIVED = 'zola/onboard/SLUG_SUGGESTIONS_RECEIVED';



/** WEBPACK FOOTER **
 ** ./src/actions/types/OnboardActionTypes.js
 **/